module.exports = {"140525100":"南村镇","140525101":"下村镇","140525102":"大东沟镇","140525103":"周村镇","140525104":"犁川镇","140525105":"晋庙铺镇","140525106":"金村镇","140525107":"高都镇","140525108":"巴公镇","140525109":"大阳镇","140525110":"山河镇","140525111":"大箕镇","140525112":"柳树口镇","140525113":"北义城镇","140525114":"川底镇","140525115":"南岭镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140525.json
// module id = 399
// module chunks = 0